import type { Tracking } from "@otto-ec/tracking-bct";

import type { synteticEvents } from "./event/event";
import type { TrackingFunctionParameterMap } from "./parser/params.js";
import type { EventTopic } from "../nexus/event/event.types";
import type { ReleaseLock } from "./init/defer";
import type { AsyncNamespace } from "../nexus/namespace/namespace.types";
import type { ExtendedPromise } from "../../exports/nexus";

/**
 *
 *
 */
export const PREFIX = "tr-v1";

/**
 *
 *
 *
 *
 */
export type DataTrackingSubmitTrackingEventDetail<P extends keyof Tracking> = {
  /**
 *
 */
  eventName: string;
  /**
 *
 */
  method: P;
  /**
 *
 *
 *
 *
 *
 */
  parameters: Parameters<Tracking[P]>;
  /**
 *
 *
 *
 *
 *
 */
  parameterMap: TrackingFunctionParameterMap[P];

  /**
 *
 *
 */
  abort(): void;
};

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export interface DataTrackingCustomEventDetail<Method extends keyof Tracking = keyof Tracking> {
  /**
 *
 *
 */
  [PREFIX]: {
    /**
 *
 *
 *
 */
    method?: Method;
  } & Partial<TrackingFunctionParameterMap[Method]>;
}

/**
 *
 *
 */
export interface DataTrackingEventMap {
  /**
 *
 *
 *
 *
 *
 *
 */
  "tr-submit-tracking": CustomEvent<
    {
      [P in keyof Tracking]: DataTrackingSubmitTrackingEventDetail<P>;
    }[keyof Tracking]
  >;

  /**
 *
 *
 *
 *
 *
 *
 */
  "tr-track-syntetic": CustomEvent<{
    /**
 *
 */
    event: (typeof synteticEvents)[number];
    /**
 *
 */
    options: Record<string, unknown>;
  }>;

  /**
 *
 *
 */
  "tr-become-visible": CustomEvent<{
    entry: IntersectionObserverEntry;
    /**
 *
 */
    [PREFIX]: { method: "submitMiniAction" };
  }>;

  /**
 *
 */
  "tr-page-impression": CustomEvent<{
    /**
 *
 */
    [PREFIX]: { method: "submitMerge" };
  }>;

  /**
 *
 *
 */
  "tr-init-element": CustomEvent<{ lockToken: string | symbol | object }>;
}

declare global {
  /*                                                               */
  interface ElementEventMap extends DataTrackingEventMap {}
  /*                                                               */
  interface DocumentEventMap extends DataTrackingEventMap {}

  interface NexusInterfaces {
    /**
 *
 */
    [PREFIX]: AsyncNamespace<TrackingAsync>;
  }
}

export type TrackingAsync = {
  /**
 *
 *
 *
 *
 *
 */
  onInit: EventTopic;

  /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
  lockInit(lockToken: string | symbol | object): ExtendedPromise<ReleaseLock>;

  /**
 *
 *
 *
 *
 *
 *
 */
  unlockInit(lockToken: string | symbol | object): ExtendedPromise<boolean>;
};
